import { useEffect, useMemo, useState } from 'react'
import { samplesApiService, type TemplateSample } from '../services/samplesApiService'

/**
 * A template version's sample payloads and the chosen one's parsed JSON. `samples` is null while
 * loading; `sampleData` is undefined with no sample chosen and null when its JSON does not parse.
 */
export function useTemplateSamples(templateVersionId: string | null) {
  const [samples, setSamples] = useState<TemplateSample[] | null>(null)
  const [sampleId, setSampleId] = useState<string | null>(null)

  useEffect(() => {
    if (!templateVersionId) { setSamples([]); return }
    let cancelled = false
    setSamples(null)
    samplesApiService.list(templateVersionId)
      .then(s => { if (!cancelled) { setSamples(s); setSampleId(s[0]?.sampleId ?? null) } })
      .catch(() => { if (!cancelled) setSamples([]) })
    return () => { cancelled = true }
  }, [templateVersionId])

  const sample = samples?.find(s => s.sampleId === sampleId) ?? null
  const sampleData = useMemo(() => {
    if (!sample) return undefined
    try { return JSON.parse(sample.payloadJson) as unknown } catch { return null }
  }, [sample])

  return { samples, sampleId, setSampleId, sampleData }
}
